var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox',{attrs:{"name":"items[]"},model:{value:(_vm.item.checked),callback:function ($$v) {_vm.$set(_vm.item, "checked", $$v)},expression:"item.checked"}},[_vm._v("\n  "+_vm._s(_vm.item.value)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40dc7b97","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Base/Checkbox/Checkbox.vue
// module id = null
// module chunks = 